//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '@/api/api'
import * as QRCode from 'easyqrcodejs'

import firebase from 'firebase/app'
import 'firebase/firestore'
import restaurantsTable from '@/components/dashboard/admin-dashboard/restaurantsTable'
import restaurantsForm from '@/components/dashboard/admin-dashboard/restaurantsForm'

export default {
    data() {
        return {
            left: false,
            alert: false,
            data: [],
            filterOptions: [
                {label: 'Todos', value: ''},
                {label: 'Whatsapp Pedidos', value: 'Whatsapp Pedidos'},
                {label: 'Carta Digital', value: 'Carta Digital'},
            ],
            displayLoading: false,
            displayAlert: false,
            alertTitle: '',
            alertMessage: '',
            alertType: '',
            filterName: '',
            filterEmail: '',
            filterType: '',
            restaurantToForm: {},
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        filteredData() {
            return this.data.filter(
                rest =>
                    rest.restaurantName
                        .toLowerCase()
                        .includes(this.filterName.toLowerCase()) &&
                    rest.email
                        .toLowerCase()
                        .includes(this.filterEmail.toLowerCase()) &&
                    rest.type.includes(this.filterType)
            )
        },
    },
    methods: {
        toggleActiveStatus(event) {
            this.displayLoading = true
            api.updateAdminRestaurantInfo({
                Restaurant: {active: event.active},
                id: event.id,
            })
                .then(response => {
                    this.displayLoading = false
                    this.alertType = 'success'
                    this.alertTitle = 'Éxito!'
                    this.alertMessage = 'Se ha actualizado el estado con éxito'
                    this.displayAlert = true
                })
                .catch(error => {
                    this.displayLoading = false
                    console.log(error)
                })
        },
        sendRestaurantToForm(event) {
            this.restaurantToForm = this.data.find(rest => rest.id == event.id )
        },
        CreateQrCode(rest) {
            let options = {
                text: `https://mimenudigital.app/${rest.url}`,
                width: 256,
                height: 256,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.L, // L, M, Q, H
                dotScale: 1, // Must be greater than 0, less than or equal to 1. default is 1
            }
            setTimeout(() => {
                new QRCode(this.$refs.qrcode, options)
            }, 500)
            this.alert = true
        },
        addToData(id, data) {
            data.id = id
            this.data.push(data)
        },
        editData(id, data) {
            data.id = id
            this.data.forEach((d, index) => {
                if (d.id === id) {
                    this.data.splice(index, 1, data)
                }
            })
        },
        // For potential future use
        // removeData(id) {
        //     this.data.forEach((d, index) => {
        //         if (d.id === id) {
        //             this.data.splice(index, 1)
        //         }
        //     })
        // },
        cleanRestaurantToForm() {
            this.restaurantToForm = {}
        },
    },
    mounted() {
        let db = firebase.firestore()
        db.collection('Restaurants').onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                if (change.type === 'added') {
                    this.addToData(change.doc.id, change.doc.data())
                }
                if (change.type === 'modified') {
                    this.editData(change.doc.id, change.doc.data())
                }
                if (change.type === 'removed') {
                    this.removeData(change.doc.id)
                }
            })
        })
    },
    components: {
        restaurantsTable,
        restaurantsForm,
    },
}
